// Importation des modules Firebase nécessaires
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

// Configuration de votre projet Firebase
const firebaseConfig = {
    apiKey: "AIzaSyBHgDd0Ab7JFA5iCmiBtP7_qDqrpTazqtY",
    authDomain: "kimmel-parcgest.firebaseapp.com",
    projectId: "kimmel-parcgest",
    storageBucket: "kimmel-parcgest.firebasestorage.app",
    messagingSenderId: "324189753256",
    appId: "1:324189753256:web:8a4b2088c5e667e408979d"
};

// Initialisation de Firebase
const app = initializeApp(firebaseConfig);

// Accès à Firebase Storage
const firebaseStorage = getStorage(app);

// Export de la variable storage
export default firebaseStorage;